import { render, staticRenderFns } from "./AllInvestmentsReceivablesDownloadAssignmentDocumentsModal.vue?vue&type=template&id=2bca6b16&"
import script from "./AllInvestmentsReceivablesDownloadAssignmentDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesDownloadAssignmentDocumentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports